'use client'

import { type ComponentProps, type FC } from 'react'

import {
  RecommendationGrid,
  RecommendationProductCard,
  type RecommendationServiceType,
} from '../../../recommendation'

import { StoryblokRecommendationWidgetRenderer } from './StoryblokRecommendationAreaRenderer'

type StoryblokRecommendationGridRendererProps = {
  cid?: string
  editableProps?: ComponentProps<'div'>
  serviceId: RecommendationServiceType
  widgetId: string
}

export const StoryblokRecommendationGridRenderer: FC<
  StoryblokRecommendationGridRendererProps
> = ({ cid, editableProps, serviceId, widgetId }) => {
  return (
    <StoryblokRecommendationWidgetRenderer
      cid={cid}
      containerClassName="w-full"
      editableProps={editableProps}
      renderProducts={({ onGtmDataLayerPush, widgetData }) => (
        <RecommendationGrid
          onGtmDataLayerPush={onGtmDataLayerPush}
          products={widgetData?.content}
          slots={{
            itemContent: RecommendationProductCard,
          }}
        />
      )}
      serviceId={serviceId}
      widgetId={widgetId}
    />
  )
}
